import React from 'react';
import {
  AccordianStyles,
  AccordianTemplateProps,
  RadioInputElement,
} from '../../..';

export const AccordianDefaultTemplate = (props: AccordianTemplateProps) => {
  return (
    <AccordianStyles
      className={`h-full ${props.classes}`}
      id={props.id}
      data-component="AccordianPartial"
    >
      <div className="accordian-container">
        {props.slots &&
          props.slots.length &&
          props.slots.map((slot, index) => {
            return (
              <div key={index} className="slot">
                {slot.active ? (
                  <div className="slot-visible accordian-content-active">
                    <div>
                      <RadioInputElement
                        {...{
                          id: slot.id,
                          name: slot.name,
                          inlay: slot.inlay,
                          template: slot.template,
                          styleClasses: slot.styleClasses,
                          isChecked: slot.active,
                          isDisabled: slot.disabled,
                          hideValidity: true,
                          onClickHandler: props.onChange,
                        }}
                      />
                      {slot.offer && !slot.active && (
                        <div className="save-text-accordian-inactive">
                          {slot.offer}
                        </div>
                      )}
                    </div>
                    <div className="slot-content">{slot.content}</div>
                  </div>
                ) : (
                  <div className="slot-hidden accordian-content-hidden">
                    <div>
                      <RadioInputElement
                        {...{
                          id: slot.id,
                          name: slot.name,
                          inlay: slot.inlay,
                          template: slot.template,
                          styleClasses: slot.styleClasses,
                          isChecked: slot.active,
                          isDisabled: slot.disabled,
                          hideValidity: true,
                          onClickHandler: props.onChange,
                        }}
                      />
                      {slot.offer && !slot.active && (
                        <div className="save-text-accordian-inactive">
                          {slot.offer}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
      </div>
    </AccordianStyles>
  );
};
